import React, { useMemo, useState } from 'react';
import { AdminPageHeader, AdminDevRowMeta, btnLink, btnPrimary, filtersRowClass, selectClass } from '../adminUi';
import { useGrading } from './GradingContext';
import { GradingContextPath, GradingDeleteButton, GradingEmptyState } from './GradingShared';
import { confirmAndRunDelete, formatPath, getCalibrationForFamily } from './utils';
import { deleteGradingCalibration } from '../../../../services/gradingService';

export default function GradingCalibrationTab() {
  const { families, roleClusters, calibrationQuestions, calibrationAnswers, openDrawer, reload } = useGrading();
  const [familyFilter, setFamilyFilter] = useState('');

  const rows = useMemo(() => {
    return families
      .filter((f) => !familyFilter || Number(f.id) === Number(familyFilter))
      .map((f) => {
        const { question, answers } = getCalibrationForFamily(f.id, calibrationQuestions, calibrationAnswers);
        const clusters = roleClusters.filter((s) => s.family_id === f.id);
        return { f, question, answers, clusters };
      });
  }, [families, roleClusters, calibrationQuestions, calibrationAnswers, familyFilter]);

  return (
    <div>
      <AdminPageHeader
        title="Калибровка Role cluster"
        subtitle="Один вопрос на Family: ответ напрямую определяет Role cluster"
        actions={
          families[0] && (
            <button type="button" className={btnPrimary} onClick={() => openDrawer({ type: 'calibration', mode: 'edit', familyId: families[0].id })}>
              Настроить калибровку
            </button>
          )
        }
      />

      <div className={filtersRowClass}>
        <select className={selectClass} value={familyFilter} onChange={(e) => setFamilyFilter(e.target.value)}>
          <option value="">Все Family</option>
          {families.map((f) => <option key={f.id} value={f.id}>{f.name}</option>)}
        </select>
      </div>

      <div className="space-y-4">
        {rows.map(({ f, question, answers, clusters }) => (
          <div key={f.id} className="dc-grading-question-card dc-grading-question-card-open">
            <div className="dc-grading-question-head">
              <div className="flex-1 text-left">
                <p className="font-medium text-slate-900">{f.name}</p>
                <AdminDevRowMeta parts={[
                  question && `calibration_questions.id=${question.id}`,
                  question && `calibration_questions.family_id=${question.family_id}`,
                ]} />
                <GradingContextPath path={formatPath([f.name])} />
              </div>
              <div className="flex items-center gap-3">
              <button type="button" className={btnLink} onClick={() => openDrawer({ type: 'calibration', mode: 'edit', familyId: f.id })}>
                {question ? 'Редактировать' : 'Добавить'}
              </button>
              {question && (
                <GradingDeleteButton
                  label="Удалить"
                  onClick={() => confirmAndRunDelete(
                    'калибровку',
                    `Калибровочный вопрос Family «${f.name}» и все ответы будут удалены.`,
                    () => deleteGradingCalibration(f.id),
                    reload,
                  )}
                />
              )}
              </div>
            </div>
            <div className="dc-grading-question-body">
              {!question ? (
                <GradingEmptyState>Калибровочный вопрос не задан</GradingEmptyState>
              ) : (
                <>
                  <p className="font-medium text-slate-800 mb-3">{question.question_text}</p>
                  <AdminDevRowMeta parts={[`calibration_questions.id=${question.id}`]} />
                  <ol className="dc-grading-answers-list">
                    {answers.map((a, idx) => {
                      const target = clusters.find((s) => s.id === a.target_role_cluster_id);
                      return (
                        <li key={a.id}>
                          <span className="dc-grading-answer-num">{idx + 1}.</span>
                          <span className="flex-1">{a.answer_text}</span>
                          <AdminDevRowMeta parts={[
                            `calibration_answers.id=${a.id}`,
                            `calibration_answers.target_role_cluster_id=${a.target_role_cluster_id}`,
                          ]} />
                          <span className="text-xs text-indigo-600">→ {target?.name || `Role cluster #${a.target_role_cluster_id}`}</span>
                        </li>
                      );
                    })}
                  </ol>
                  {answers.length === 0 && <p className="text-sm text-amber-600">Нет ответов — калибровка не работает</p>}
                  {clusters.length === 0 && <p className="text-sm text-amber-600">Нет Role cluster в этой Family</p>}
                  {clusters.length > 0 && (
                    <div className="mt-4 pt-3 border-t border-slate-100">
                      <p className="text-xs font-medium text-slate-500 mb-2">Role cluster в Family</p>
                      <div className="flex flex-wrap gap-2">
                        {clusters.map((rc) => (
                          <span key={rc.id} className="inline-flex flex-col items-start">
                            <span className="dc-grading-type-badge dc-grading-type-calibration text-xs">
                              {rc.name}
                              <button
                                type="button"
                                className={`${btnLink} ml-1 text-[10px]`}
                                onClick={() => openDrawer({ type: 'role_cluster', mode: 'edit', id: rc.id })}
                              >
                                ✎
                              </button>
                            </span>
                            <AdminDevRowMeta parts={[`role_clusters.id=${rc.id}`, `role_clusters.family_id=${rc.family_id}`]} />
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
